"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function _getInt(s, start, length) {
    if (start < s.length) {
        return +s.substr(start, length);
        var res = +s.substr(start, length);
        if (!isNaN(res)) {
            return res;
        }
    }
    return 0;
}
/**
 * zwraca liczbę reprezetującą częśc daty
 * @param date data w formacie yyyy-MM-dd HH:mm:ss
 * @param part rok:y,yy,yyy,year;
 * miesiąc:M,MM,month;
 * dzien:d,dd,day;
 * godzina:h,hh,hour;
 * minuta:m,mm,minute;
 * sekunda:s,ss,second;
 */
function datePart(date, part) {
    switch (part) {
        case 'y':
        case 'yy':
        case 'yyyy':
        case 'year':
            return _getInt(date, 0, 4);
        case 'M':
        case 'MM':
        case 'month':
            return _getInt(date, 5, 2);
        case 'd':
        case 'dd':
        case 'day':
            return _getInt(date, 8, 2);
        case 'h':
        case 'hh':
        case 'hour':
            return _getInt(date, 11, 2);
        case 'm':
        case 'mm':
        case 'minute':
            return _getInt(date, 14, 2);
        case 's':
        case 'ss':
        case 'second':
            return _getInt(date, 17, 2);
        default:
            return 0;
    }
}
exports.default = datePart;
//# sourceMappingURL=datePart.js.map